import styled from 'styled-components';
import { mediumBreakpoint } from 'utilities/constants';

export const ContentBlock = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  max-width: 100%;
  width: calc(50% + 2rem);
  display: inline-block;

  @media (max-width: ${mediumBreakpoint}px) {
    padding: 1.5rem 0;
    width: 100%;
  }

  &:first-child {
    @media (max-width: ${mediumBreakpoint}px) {
      min-height: 100%;
      margin-left: 0;
    }
  }

  &:nth-child(2) {
    padding-top: 0;
    min-height: 100%;
  }

  p {
    &:first-child {
      text-transform: uppercase;
      color: #1058a3;
      letter-spacing: 0.175rem;
      width: calc(100% + 0.175rem);
      font-size: 0.875em;
      line-height: 1.75;
      font-weight: bold;
      margin: 1.5rem 0;
    }
  }

  h2 {
    color: #242424;
    font-size: 2em;
    /* font-size: 2.875em; */
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    line-height: 1.125;
    text-align: left;
    margin: 1.5rem 0;
  }
`;
